import Registration from './Registration.vue';
import Login from './Login.vue';
import ForgotPassword from './ForgotPassword.vue';
import ResetPassword from './ResetPassword.vue';
import ChangePassword from './ChangePassword.vue';
import ConfirmEmail from './ConfirmEmail.vue';
import UserSettings from './UserSettings.vue';
import UserProfile from './UserProfile.vue';
import UserProfileEdit from './UserProfileEdit.vue';
import RegistrationUser from './RegistrationUser.vue';
import RegistrationAgent from '@/estate-agent/RegistrationAgent.vue';
import RegistrationAgentCompetition from '@/estate-agent/RegistrationAgentCompetition.vue';
import RegistrationAgentLandingPage from '@/estate-agent/RegistrationAgentLandingPage.vue';
import EstateAgencyProfile from '@/estate-agency/EstateAgencyProfile.vue';
import EstateAgencyProfileEdit from '@/estate-agency/EstateAgencyProfileEdit.vue';
import { config } from '@/shared/constants';

const accountRoutes = [
  {
    path: '/registration-agent',
    name: 'RegistrationAgentLandingPage',
    component: RegistrationAgentLandingPage,
    meta: {
      showHeader: false,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/registration-competition',
    name: 'RegistrationAgentCompetition',
    component: RegistrationAgentCompetition,
    meta: {
      showHeader: false,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/registration',
    component: Registration,
    children: [
      {
        path: 'agent',
        name: 'RegistrationAgent',
        component: RegistrationAgent,
        meta: {
          isDisabled: config.IS_ESTATE_AGENCY_MODE,
        },
      },
      {
        path: '',
        name: 'Registration',
        component: RegistrationUser,
        meta: {
          isDisabled: config.IS_ESTATE_AGENCY_MODE,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      requiresAuth: true,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/confirm-email',
    name: 'ConfirmEmail',
    component: ConfirmEmail,
    meta: {
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      requiresAuth: true,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/settings',
    name: 'UserSettings',
    component: UserSettings,
    meta: {
      requiresAuth: true,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/profile-edit',
    name: 'UserProfileEdit',
    component: UserProfileEdit,
    meta: {
      requiresAuth: true,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/profile-agency',
    name: 'EstateAgencyProfile',
    component: EstateAgencyProfile,
    meta: {
      requiresAuth: true,
      requiresEstateAgent: true,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
  {
    path: '/profile-agency-edit',
    name: 'EstateAgencyProfileEdit',
    component: EstateAgencyProfileEdit,
    meta: {
      requiresAuth: true,
      requiresEstateAgent: true,
      isDisabled: config.IS_ESTATE_AGENCY_MODE,
    },
  },
];

export default accountRoutes;
